import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import logo from '../../assets/kvp.png';
import './Header.css';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-brand">
          <img src={logo} alt="KVP Trade LTD" className="header-logo" />
        </div>
        <nav className="header-nav">
          <div className="nav-links">
            <a href="#shop" className="nav-link">Shop</a>
            <a href="#about" className="nav-link">About</a>
            <a href="#support" className="nav-link">Support</a>
          </div>
          <a href="#shop" className="header-cta">Bulk Deals</a>
        </nav>
        <div
          className="hamburger"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? (
            <X className="hamburger-icon" size={28} />
          ) : (
            <Menu className="hamburger-icon" size={28} />
          )}
        </div>
        <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
          <a href="#shop" className="mobile-nav-link">Shop</a>
          <a href="#about" className="mobile-nav-link">About</a>
          <a href="#support" className="mobile-nav-link">Support</a>
          <a href="#shop" className="mobile-cta">Bulk Deals</a>
        </div>
      </div>
    </header>
  );
};

export default Header;